import { render } from "./TariffPlanCard.vue?vue&type=template&id=6bb50782"
import script from "./TariffPlanCard.vue?vue&type=script&lang=js"
export * from "./TariffPlanCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__